webpackJsonp([28686525722576],{

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _MainPicture = __webpack_require__(21);
	
	var _MainPicture2 = _interopRequireDefault(_MainPicture);
	
	var _centraliserDonnees = __webpack_require__(102);
	
	var _centraliserDonnees2 = _interopRequireDefault(_centraliserDonnees);
	
	var _LeftPictureBackground = __webpack_require__(20);
	
	var _LeftPictureBackground2 = _interopRequireDefault(_LeftPictureBackground);
	
	var _apps = __webpack_require__(785);
	
	var _apps2 = _interopRequireDefault(_apps);
	
	var _communicationService = __webpack_require__(788);
	
	var _communicationService2 = _interopRequireDefault(_communicationService);
	
	var _RightPicture = __webpack_require__(33);
	
	var _RightPicture2 = _interopRequireDefault(_RightPicture);
	
	var _CheckModule = __webpack_require__(32);
	
	var _CheckModule2 = _interopRequireDefault(_CheckModule);
	
	var _surMesure = __webpack_require__(817);
	
	var _surMesure2 = _interopRequireDefault(_surMesure);
	
	var _technologies = __webpack_require__(42);
	
	var _technologies2 = _interopRequireDefault(_technologies);
	
	var _symfony = __webpack_require__(41);
	
	var _symfony2 = _interopRequireDefault(_symfony);
	
	var _nodejs = __webpack_require__(40);
	
	var _nodejs2 = _interopRequireDefault(_nodejs);
	
	var _angularReact = __webpack_require__(37);
	
	var _angularReact2 = _interopRequireDefault(_angularReact);
	
	var _baseDeDonnee = __webpack_require__(38);
	
	var _baseDeDonnee2 = _interopRequireDefault(_baseDeDonnee);
	
	var _elasticsearch = __webpack_require__(67);
	
	var _elasticsearch2 = _interopRequireDefault(_elasticsearch);
	
	var _htmlCssJs = __webpack_require__(39);
	
	var _htmlCssJs2 = _interopRequireDefault(_htmlCssJs);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Webapp = function (_Component) {
	  _inherits(Webapp, _Component);
	
	  function Webapp() {
	    _classCallCheck(this, Webapp);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Webapp.prototype.render = function render() {
	    var title = "Application Web";
	    var goto = "En découvrir plus";
	    var alt = "test";
	    var description = ["Nous vous accompagnons dans la  ", _react2.default.createElement(
	      "strong",
	      null,
	      "r\xE9alisation de portails Web"
	    ), " adaptés à votre organisation. Un de nos objectifs est de vous permettre de centraliser et retrouver vos données en toute ", _react2.default.createElement(
	      "strong",
	      null,
	      "simplicit\xE9 et s\xE9curit\xE9"
	    ), "."];
	
	    var smalltitle = "Optimiser l'exploitation de vos données";
	    var titlemethodo = "Aggrégation d'outils au service de votre efficacité";
	    var descriptionmethodo = ["La mise en place d'un intranet ou portail au sein de votre organisation a l'avantage de centraliser vos données, mais aussi vos outils en ", _react2.default.createElement(
	      "strong",
	      null,
	      "un seul et unique syst\xE8me"
	    ), ".", _react2.default.createElement("br", null), "Vous pouvez par exemple retrouver:", _react2.default.createElement(
	      "ul",
	      null,
	      _react2.default.createElement(
	        "li",
	        null,
	        "La saisie des demandes de cong\xE9s,"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "la gestion des notes de frais,"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "la base de donn\xE9es client,"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "CRM,"
	      ),
	      _react2.default.createElement(
	        "li",
	        null,
	        "..."
	      )
	    ), "Les processus internes sont disponibles et encadrés autour d'une seule application accessible partout et tout le temps !"];
	    var pictureMethodo = _apps2.default;
	    var altmethodo = "Méthodologie agile Scrum en image";
	
	    var smalltitleevol = "Faite évoluer votre portail avec votre organisation";
	    var titleevol = "Le portail sur-mesure";
	    var descriptionevol = ["Nous vous apportons notre expertise composée du ", _react2.default.createElement(
	      "strong",
	      null,
	      "conseil"
	    ), " et de l'accompagnement nécessaire à la réalisation d'un portail collaboratif efficace.", _react2.default.createElement("br", null), "Toute structure est unique, c'est pourquoi nous privilégions la conception de portail intranet/extranet sur-mesure.", _react2.default.createElement("br", null), _react2.default.createElement("br", null), "Notre expérience dans le ", _react2.default.createElement(
	      "strong",
	      null,
	      "syst\xE8me d'information"
	    ), " vous garantit une intégration ", _react2.default.createElement(
	      "strong",
	      null,
	      "s\xE9curis\xE9e"
	    ), " et optimale dans votre environnement informatique afin d'éviter la dupplication de données et les ressaisies rébarbatives."];
	
	    var altevol = "Intégration du portail dans votre système d'informations";
	
	    var smalltitleCheck = "Intégrer vos clients et fournisseurs dans votre communication 360°";
	    var titleCheck = "Carrefour de la communication entre tous les acteurs de votre organisation";
	    var subtitle1Check = "Vos clients";
	    var text1Check = ["Gardez vos clients au centre de votre préoccupation en les invitants à utiliser votre portail. Améliorez la traçabilité de vos communications !", _react2.default.createElement("br", null), "Proposez des services en ligne inédits !"];
	    var subtitle2Check = "Vos fournisseurs et partenaires";
	    var text2Check = "Communiquez efficacement avec vos partenaires tout en gardant une traçabilité de vos échanges.";
	    var subtitle3Check = "Vos collaborateurs";
	    var text3Check = "Toute votre structure peut communiquer en interne et avec des tiers. Le suivi et le partage de l'information  optimisent la transmission de la connaissance !";
	    var pictureCheck = _communicationService2.default;
	    var altCheck = "La communication 360°";
	
	    return _react2.default.createElement(
	      "div",
	      { className: "generic-services" },
	      _react2.default.createElement(_MainPicture2.default, { title: "Centraliser vos donn\xE9es pour am\xE9liorer votre productivit\xE9", description: description, picture: _centraliserDonnees2.default, alt: alt }),
	      _react2.default.createElement(_RightPicture2.default, { smalltitle: smalltitleevol, title: titleevol, description: descriptionevol, picture: _surMesure2.default, alt: altevol }),
	      _react2.default.createElement(_LeftPictureBackground2.default, { smalltitle: smalltitle, title: titlemethodo, description: descriptionmethodo, picture: pictureMethodo, alt: altmethodo }),
	      _react2.default.createElement(_CheckModule2.default, {
	        smalltitle: smalltitleCheck,
	        title: titleCheck,
	        subtitle1: subtitle1Check,
	        text1: text1Check,
	        subtitle2: subtitle2Check,
	        text2: text2Check,
	        subtitle3: subtitle3Check,
	        text3: text3Check,
	        picture: pictureCheck,
	        alt: altCheck
	      }),
	      _react2.default.createElement(_RightPicture2.default, { smalltitle: smalltitleevol, title: titleevol, description: descriptionevol, picture: _surMesure2.default, alt: altevol })
	    );
	  };
	
	  return Webapp;
	}(_react.Component);
	
	exports.default = Webapp;
	module.exports = exports["default"];

/***/ }),

/***/ 785:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAA0IAAAP6CAMAAACKGR1eAAAALVBMVEX///86g7yxzLPM18/R2tPW3tja4dzf5eDj6OTo7Ont8O3x9PL2+Pf7/Pv///9u/2O4AAAAAXRSTlMAQObYZgAAEQJJREFUeAHs00EBQAAUQLGvf2kFnMCDrcOG2nLMgDbH+YQ4MkFfRyXc6SuBPCIhTx8J7BEJe/pHYI9H6NM3Ans8Qh+N0Ecj/NEI9LEIfTTCH4vwRyPwxyL0sQh/LMIfixAIi/DHIvyxCH8sQiAkwh+LEEgi/LEIgZAIfyxCIIkQyCL8QSKBkAiBJEIgi/AHiQRCIgSSCIEkQiAkEgiJBEIiBJIIgZDIICQSCIkQyCEEkgiBkEggJMIgiRDIIQRCIoOQSCAcQiCJMAiJBMIhgZAIgyRCIBwyCIkEwiEMkgiBcEggJDIIhwxCIgTCIYOQSCAcMgiHEAiJDMIhg5BIIBzCIBwyCIkEwiGDcMggJEIgHDIIhwzCIYGQCINwyCAcMgiHDEIiBMIhg3DIIBwyCIcMAocEQiKDcMggHDIIHDIIhwzCIYNwSCBwyCAcMgiJDMIhg8AgcMggHDIIhwzCIYPAIYNwyCAcMgiHDAKHDMIhg3DIIBwyCBzaHgQOGYRDBuGQQWAQhIUMAoOgPGQQGATlIYPAICgPKQQGQXnIIDAIwkIGgUFQHjIIDILykEJgEISFDAKDoDxkEBgE5SGFwCAICxkEBkF5yCAwCBQChwzCIYNwyCBQCBwyCIcMwiGDQCFwyCAcMgiHDAKF4KmHDAKDICxkECgE5SGDwCBQCBwyCIdeNQgUAocMwiGDwCAoDykEBkFYyCBQCMJCBoFCEB4yCAyC8pBCYBCEhQwChSAsZBCEg8AhhSAcBA4pBOUgcMggCAuBQgZBWAgUMgjCQqCQQWAQKBQCg0I4pBAYFMIhhcCgEA4pBAbBMQaBQiEwCBQKgUGgUAgMAoVCYBAoFAKDQKEQGAQKhcAgUCgEBoFCITAIFOqAQSEcUggM4kwOKQQre3eC4CiOBFBUwhhsFt3/trN69qnOcioNUvD+EZp+hQgrJYQOTSJIQkg6MYJ6TQhJCBEkIVSV9NOCJIYQGqdlWcvH0rI8piEoIYSGeSuHpPUezxBB90P96DmEIoTQtJeD0zIglKM0bOWE9AxiCKG5nJP2WwRCBK3ltDT3bwihvajbxRxCBGkNQIigM9NyWUME/Ux6XJSQScJPpTtCvTaVJlLuuUsTKjJSqO7Kgpai07KUy/03FrXSjlCPbUXNNMUjFF/QraidttxxVyX0LGqoMfebcZzslUPIMKH7csdZx6mBbpciZHecfrwZIZ9CuuyG7SsSGopOy8dQtsNUCCGkxhquY8ipPUIIoaWokRBCSAjlUwUhJIQQEkIICaGKehGEEEIIISSEEFoe03+l51pP6AqGMkL7/IuHrfGJEEJftY1Z370vECGE9nvWFz0uSigj9EN/06JhRyi+oLx88AoCrQghdPg5TQwNObghhKZcG0MI5QsTemS90YYQQlUn1gohhKoesKYL/he+kqC8WMYdeVIfQghlvduIEEJVLyHtlyOULyQoLx9/vJoRQsg4riqEELKOq2pHCKGarT16Xo5Qvo6gvHz+6WpCCCEj7ZpGhBBC6LgbaBBCSAjleIIQQgghhBBCCCGEEMoICaEaQwgJIYQQQgghhBBquipBCAmhHIsQQgghhBBCCCGEEEIZISFUYQih4CGEEEIIIYQQQgghJIRyJEEIIYQQQgghhBBCCCFUEUIIZYSEUI0hhOKHEEIIIYQQQgghhJAQqhKEkBDKCCGEEEIIIYQQQgghhBBCCL0pCCEhlBFCCCGEEEIIIYQQQgihC4fQCYIQQgghhIRQRgghhBBCCCGEEEIIIYSuG0JnCEIIIYQQEkIZIYQQQgghhBBCCCGEELpiCHUqCCGEEEIIIYQQEkIZIYQQQgghhBBCCCGEELpiCMUUhBBCCCGEEEIIIYQQQkLoixBCCCGEEEIIIYQQQgihK4bQm4IQEkIIIYQQQgghhBBCCCGEkBDKCCGEEEIIIYQQQgghhNAVQ6gbQQghhBBCCCGEkBBCCCGEEEIIIYQQQgghhIRQRgghhBBC6NAQQgghhBBCCCGEEEIIIYSEUG43hBBCCCGEEEJICCGEEEIIIYQQQgghhBBCQgghhBBCCCGEEEIIIYQQEkIIIYQQQgghhBBCCCGEEEIIISSEEEIIIYQQQgghhBBCCCEhhBBCCCGEEEIIIYQQQggJIYQQQgghhBBCCCGEEEJICCGEEEIIIYQQQgghhBBCCCGEkBBCCCGEEEIIIYQQQgghhIQQQgghhBBCCCGEEEIIIRQ/hBBCCCGEEEIIIYQQQgghIYQQQgghhBBCCCGEEEIICSGEEEIIIYQQQgghhBBCSAghhBBCCCGEEEIIIYQQQrpdnlCVIYQ0IYTQq1v+RnoihNCrOX8jbQgh9GrL30gFIYR8DP3IpxBCCD1yRdZxCCG053fTWK5OKCH0b035zbQhhJCvoYru5d9DCKElv5V2hBCylKtoLQilv4TQvzVm/XaPghBCDP2sIIQQYqhOEEII+YW17jsIIYTKNuQv0n0vCCH06xaI/rBxK38PoYTQL1rH/Is0vwAhhNAXih7ToP9snJ4vPwghpJ8KoYTQAQkhhIQQQmckhBASQggJoQ+UEPp1QgihuRyREEoOaBJCCCHUQxmhrroVIYRQTUVttSKEkGp6hBNkqn1oGqMSSk4KPCRlhKzk5FPoUoTWooa6I9RdY1E77Rmh/tqLzOM+Lyi5hE2GCVWEkgtw9PFmhGzykS+h6xHKz6ImuiFkKSezhH8vHUfI76tac7zSYYb8OKQtI8SQjBK+RYgheQchlG97ke8ghGw47bI5rKADDNnqo4o7AxHyN6zapxwnhPLwLAIIoaqmtRyUnmO+kqCUL9P4WIo+27ZMtxy8FMJQRYM+Vm44hCSEJIQkghiSEJIQkhCSCHqHkKTEkISQhJCEkERQdEPD6QmhbhufRU20zgh12LQXtdMyINRXw1bUVktsQdEMzUXNtd8QcmCPqhoRcvaiLm4o/UEEiSGECAp94R1CvoO0I9R6j6KmWyMKeuU6IbntAaG9qPUGhIwSVNMWllCyKeGQNAUVFIDQUNRFCLXaVr5oX6b7oM92mx5rnztOEZq/8DPno9K4RPyBNaXghv4Y0JgPTUtvEwWElrZ+jNC4dzVRQGj0CmquPdg+nxTb0N7eviyVX/aIKSgFnSWM+Zx072ewjVCTv+RpiTTYTqENLW1OfxRobZBCExos4xrt0cc/bQht/b2ETOUmhNrp7iXUbFOUQWlKkQ3t7W7H0tb+YBuhueG/79LY/sNBqOk9wVpDPJ2UAhtavIR6HZeOCLXQ4CXUeEvbEwWENi+h1guwcyS9UYih6atnVuOH+yHU9rFXWa0/pCdCLZ9e+shqfqkwhBPUm6HOD4rxGloROrfFS6iLxkYH2wjdvIS6n5vu4QR1ZWjr/yXk99UZofOaIlxk40yseIRSiIH2lNXJa2gJJyiFuI4rq63W9gbbCB1ymZocb5GiGlqKT6Eg20ju0QSlCHdC3rO6WXXvCJ3R1tFFUHr2ewFrSkENTeWrNoga6fYoX4VQoxcT78s0DkM+Kw3DNC/lN1oQOrpHebNtOTKt5b1uAQSdaMi1qtoQOralKFhTMEKp/YG2YrUHE5TaH2grWA+EjmsqClgsQW0b2osCtiB0VM+ikI2xCCUD7ctnsJ1iElqLgjYhZKAdKYPtVJlZQl8ZbCNkoK0hFKE2DRVFbgklKBlo95XBNkIG2toiCTrBkIG2JoQMtKsmS+aYoQgl/yMcPlgyyHxGEtQaodlc6dsZbCP0l4yVvt+jdNMaSFBjhhZTpe83GGwjNFxkqGSYuQcS1JShzUyppvHqg22E7tfZK+nAiUiEkoH22zlxov+RZgpIaPb4a7Njuw9Cnv+t+0OUDTXTj2agfcLD9xq6I/Sz3Tz7ix2jvIcQ9Mo06YRH79iJGaGfbPLkr3eQchxB9YZs1ffb2rmTTYQeduof+G+R0WaKYMhGfXPtssURlAySznjqDkCa4hBKBtq/2eh6wO6nm+lMQsZIU+s9HW56IUKOL1UEQa8MkXRGC0J9zZBksJ1SJEOOL9WGUE8TJBlspxTLkPu4tCPUz0BbBtvpoxlo65QGhCp6Lrp804mCAhiSMkISQScbkhCSCKo3JCEkEXS+IQkhiaDzDUkISQQxJCEk1QtiSEJIOl9QFEOT9AqhmrNrpWcUQa8O/pNVKSP0vdYiHXCKTzo8B5mqjyNNERqLtIcS9MppwOrjQwghn0O6BxP0yr0O6uAkRoQcS681nqBX7nlX86MEhIwUdDtPUABDRgqazhMUwJCRgpaMkF9Y5UOoBUNz0QUbEPI5pIqmwIJeNXpzvnwIIeRzSPuJggIY8uuQBoRcXKyK5vMFxTNUZGtcIEGvmrv9Wz6EEDLZ1v08QQEMmWxryQj5uwdZxrVoaClhkmXcq2wpJ8s4SzlZxl3F0BA9ZYQkd6EwpD+zTwdFAIMAEMT8u66DAs+dSzwkQiEwyCEMUgiFHIL3QQ6BQmCQQxikEAo5BOdBDoFCYJBDGKQQCjkE/UEOYZBCKOQQZAYphEIOYZBDEBikEAo5hEEbh8AghVDIIQxyCAqDFEIhhzBIIQgMcgiFHMIghRhgkEMo5BAGKYRBDrFKIYcwSCEMcgiFHGKHQQphkEMo5BAGKQQGOYRCDmGQQhjkEIsMcgiFFMIghzDIIVAIDHIIgxxCIYf6MEghDHIIgxwChcAghzDIIQxSCIUcAoMcwiCHUEghDHIIDHIIgxRCIYcwyCEwyCEMUgiFHMIghxhlkEMYpBAKOYRBDmGQQ2CQQhjkEAo5hEEOgUEKYZBDKOQQBjkEBimEQQ5hkEMo5BAYpBAGOYRBDmGQQyiEQxikEAY5hEEOYZBDoJBDGKQQBjmEQQ6BQQ6hkEIY5BAGOYRBOIRBDmGQQyikEAbhEAY5hEEOYZBDGIRCKOQQBjmEQQ5hEA5hkEMYpBAGOYRCDmEQDmGQQxjkEAYphEE4hEEOYZBDKOQQBuEQBjmEQQphkEMYhEMG4RAGOYRCDmEQDhmEQhjkEAY5hEE4ZBAOYZBDGOQQBjmEQiiEQQ5hkEMY5BAG4ZBBOIRBDmGQQxiEQwbhEAYphEEOYRAOKYRDGOQQBjmEQThkEA4ZhEMY5BAG4ZBBOGQQCmGQQxjkEAbhkEE4hEEOYZBDGIRDBuGQQTiEQg5hEA4ZhEMG4RAGOYRBOGQQDhmEQxjkEAahkEE4ZBAOYZBDGIRDBuGQQThkEA5hkEMYhEMG4ZBBOIRBDmEQDhmEQwbhEAY5hEE4ZBAOGYRDBuEQBuGQQThkEA4ZhEMYhEMG4ZBBOGQQDiEQDhmEQwbhkEE4ZBAOYRAOGYRDBuGQQTiEQUhkEA4ZhEMG4RAG4ZBBOGQQDhmEQxiEQwbhkEE4ZBAOCQQOGYRDBuGQQThkEDhkEA4ZhEQG4ZBBYI5BOGQQDhmEQwbhkEDgkEE4ZBAOGYRDBoFDBiGRQThkEA4ZBA4ZhEMG4ZBAOGQQfO3TSQGAQAAAof6tTeBrdE/owAuDoDGoAYMiMKgBgxowqAGDGhCoAYMaMKgBgyIwCBqDGjCoAYMaEKgBgxowqAGDIjCoAYMaMKgBgxoQqAGDIjCoAYMaMKgBgxowqAGBIjCoAYMaMKgBgxowqAGDIhCoAYMaMKgBgxowKAKDGhCoAYMaMKgBgxowKAKDGhAIGoOgMQgig6AxCBqDoBEIGoMgMggag6AxCBqDIBIIGoOgMQgag6AxCCKBoDEIGoOgMQgig6ARCBqDoDEIIoOgMQgagaAxCCKDoDEIGoMgEggag6AxCBqDIDIIGoGgMQgagyAyCBqDoBEIIoOgMQgagyBafhAPFNdv2BWdbmYAAAAASUVORK5CYII="

/***/ }),

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/centraliser-donnees.14425800.png";

/***/ }),

/***/ 788:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/communication-service.13e13a72.png";

/***/ }),

/***/ 817:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/sur-mesure.b75a8f01.png";

/***/ }),

/***/ 836:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/puzzle.2a31f7b4.jpg";

/***/ }),

/***/ 321:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(10);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Header = __webpack_require__(12);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _SocialLinks = __webpack_require__(16);
	
	var _SocialLinks2 = _interopRequireDefault(_SocialLinks);
	
	var _SEO = __webpack_require__(14);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	var _Portail = __webpack_require__(292);
	
	var _Portail2 = _interopRequireDefault(_Portail);
	
	var _HeaderPage = __webpack_require__(15);
	
	var _HeaderPage2 = _interopRequireDefault(_HeaderPage);
	
	var _Menu = __webpack_require__(13);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Footer = __webpack_require__(11);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _puzzle = __webpack_require__(836);
	
	var _puzzle2 = _interopRequireDefault(_puzzle);
	
	var _SiteConfig = __webpack_require__(6);
	
	var _SiteConfig2 = _interopRequireDefault(_SiteConfig);
	
	var _Contact = __webpack_require__(19);
	
	var _Contact2 = _interopRequireDefault(_Contact);
	
	__webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var PortailWebApp = function (_Component) {
	    _inherits(PortailWebApp, _Component);
	
	    function PortailWebApp() {
	        _classCallCheck(this, PortailWebApp);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	    }
	
	    PortailWebApp.prototype.render = function render() {
	        // SEO PURPOSES
	        var slug = this.props.pathContext.slug;
	
	
	        var postNode = {
	            "frontmatter": {
	                "title": "Création de portail Web Collaboratif",
	                "description": "Integral Service développe des portails Web de type Intranet et/ou Extranet collaboratif pour répondre aux besoins de votre métier.",
	                "cover": _puzzle2.default
	            }
	        };
	
	        var title = "Portail Web";
	        var description = "Des portails collaboratifs adaptés à vos besoins";
	        var goto = "En découvrir plus";
	
	        return _react2.default.createElement(
	            "div",
	            { className: "webapp-container page-details" },
	            _react2.default.createElement(_Header2.default, null),
	            _react2.default.createElement(_Menu2.default, null),
	            _react2.default.createElement(_reactHelmet2.default, {
	                title: "Portail Web Collaboratif | " + _SiteConfig2.default.siteTitle,
	                description: "Integral Service d\xE9veloppe des portails Web de type Intranet et/ou Extranet collaboratif pour r\xE9pondre aux besoins de votre m\xE9tier."
	            }),
	            _react2.default.createElement(_SEO2.default, { postPath: slug, postNode: postNode, postSEO: true }),
	            _react2.default.createElement(_HeaderPage2.default, { title: title, description: description, picture: _puzzle2.default }),
	            _react2.default.createElement(_Portail2.default, null),
	            _react2.default.createElement(_Contact2.default, null),
	            _react2.default.createElement(_SocialLinks2.default, { postPath: slug, postNode: postNode }),
	            _react2.default.createElement(_Footer2.default, null)
	        );
	    };
	
	    return PortailWebApp;
	}(_react.Component);
	
	exports.default = PortailWebApp;
	
	;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-portail-web-collaboratif-jsx-e06849c5a47c10786ca3.js